import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useLookups(keys = ["clients", "treatments", "operators"]) {
  const [data, setData] = useState({ clients: [], treatments: [], operators: [], products: [] });
  const k = keys.join(",");
  const reload = useCallback(async () => {
    const res = await Promise.all(k.split(",").map((x) => api.get(`/${x}`)));
    setData((p) => ({ ...p, ...Object.fromEntries(k.split(",").map((x, i) => [x, res[i].data])) }));
  }, [k]);
  useEffect(() => { reload(); }, [reload]);
  return { ...data, reload };
}
